import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';
import * as accents from 'remove-accents';
import * as moment from 'moment';
import * as PCD_LIST from 'src/assets/pcd/pcd-list.json';
import * as SINONIMO from 'src/assets/sinonimo.json';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { PlatformLocation } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { TokenService } from 'src/services/token.service';

@Component({
  selector: 'app-professional-experiences',
  templateUrl: './professional-experiences.component.html',
  styleUrls: ['./professional-experiences.component.scss']
})
export class ProfessionalExperiencesComponent implements OnInit {

  form: FormGroup;
  @ViewChild('auto', { static: false, read: MatAutocompleteTrigger }) autocomplete: MatAutocompleteTrigger;
  @ViewChild('desiredJobTitleInput') desiredJobTitleInput!: ElementRef;
  formVacancy: FormGroup;
  editMode: boolean = false;
  submiting: boolean = false;
  experiences$: Observable<any>;
  filteredDesirableJob$: Observable<any>;
  filteredVacancies$: Observable<any>;
  filteredBranch$: Observable<any>;
  filteredRoleLevel$: Observable<any>;
  filteredSpecializationName$: Observable<any>;
  allDesirableJobs: Array<any> = [];
  allVacancies: Array<any> = [];
  allBranch: Array<any> = [];
  allRoleLevel: Array<any> = [];
  allOffices: Array<any> = [];
  allSpecializationName: Array<any> = [];
  pcdList: Array<any> = [];
  sinonimos: Array<any> = (SINONIMO as any).default;
  allSinonimo
  filteredSinonimo
  filteredDesirableJobs
  mauticFormSrc: any = null;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private pLocation: PlatformLocation,
    private sanitazer: DomSanitizer,
    fb: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<ProfessionalExperiencesComponent>,
    private TokenService : TokenService
  ) {

    this.allSinonimo = this.sinonimos;
    this.allDesirableJobs = this.sinonimos;

    this.pcdList = (PCD_LIST as any).default;
    this.form = fb.group({
      lead_id: [null, Validators.required],
      isPcd: [false, Validators.required],
      desiredJobTitle: [null],
      pcdDescription: [null],
      desiredJobTitles: [[], Validators.required]
    })

    this.formVacancy = fb.group({
      id: [null],
      lead_id: [null, Validators.required],
      company: [null, Validators.required],
      vacancy: [null],
      branch: [null],
      roleLevel: [null],
      specializationName: [null],
      description: [null, Validators.required],
      currentJob: [false],
      admissionDate: [null, [Validators.required, CustomValidators.beforeDate('departureDate', 'MMyyyy'), CustomValidators.date('MMyyyy')]],
      office: [null],
      departureDate: [null, [CustomValidators.departureDate('currentJob'), CustomValidators.maxDate(moment(), 'MMyyyy'), CustomValidators.date('MMyyyy')]],
      salary: [null],
      sinonimo: [null, Validators.required],
      workregime: [null, Validators.required],
      modalityjob: [null, Validators.required],
    });

    const token = JSON.parse(localStorage.getItem('token'));

    this.http.get('desired_job', { id: token.id })
      .subscribe(
        (result: any) => {
          const { data } = result;
          const desiredJobTitles = data.desired_job_title ? data.desired_job_title.split(',').map(job => job.trim()) : [];

          this.form.patchValue({
            isPcd: data.is_pcd == 'true',
            pcdDescription: data.pcd_description,
            // desiredJobTitle: data.desired_job_title != 'undefined' ? data.desired_job_title : null
            desiredJobTitles: desiredJobTitles,
          },
            { emitEvent: false }
          );
        })

    this.form.patchValue({ lead_id: token.id }, { emitEvent: false });
    this.formVacancy.patchValue({ lead_id: token.id });
    this.formVacancy.get('currentJob')
      .valueChanges
      .subscribe(_ => this.formVacancy.patchValue({ departureDate: null }));

    // this.http.list('desired_job_aux')
    //   .subscribe(
    //     (result: any) => {
    //       this.allDesirableJobs = result.data;
    //     }
    //   )

  }

  ngOnInit(): void {

    if (this.data) {
      this.editable(true)
    }

    this.form.get('isPcd')
      .valueChanges
      .subscribe(
        isPcd => {
          if (!isPcd)
            this.form.patchValue({ pcdDescription: null });
            if(this.form.controls['pcdDescription'].value !== null)
              this.submitDesiredJobTitle();
        }
      )

      this.form.get('pcdDescription')
      .valueChanges
      .subscribe(
        pcdDescription => {
            this.submitDesiredJobTitle();
        }
      )

      

    // this.filteredDesirableJob$ = this.form.get('desiredJobTitle')
    //   .valueChanges
    //   .pipe(
    //     debounceTime(300),
    //     map(vacancy => this._filterDesirableJobs(vacancy))
    //   );

    // this.filteredVacancies$ = this.formVacancy.get('vacancy')
    //   .valueChanges
    //   .pipe(
    //     map(vacancy => this._filterVacancies(vacancy))
    //   );

    // this.filteredBranch$ = this.formVacancy.get('branch')
    //   .valueChanges
    //   .pipe(
    //     map(branch => this._filterBranch(branch))
    //   );

    // this.filteredRoleLevel$ = this.formVacancy.get('roleLevel')
    //   .valueChanges
    //   .pipe(
    //     map(role_level => this._filterRoleLevel(role_level))
    //   );

    // this.filteredSpecializationName$ = this.formVacancy.get('specializationName')
    //   .valueChanges
    //   .pipe(
    //     map(specializationName => this._filterSpecializationName(specializationName))
    //   );

    // this.http.list('vacancy')
    //   .subscribe((vacancies: any) => this.allVacancies = vacancies);

    // this.http.list('vacancy:specialization_name')
    //   .subscribe((specializationName: any) => this.allSpecializationName = specializationName);

    // this.http.list('vacancy:branch')
    //   .subscribe((branch: any) => this.allBranch = branch);

    // this.http.list('vacancy:role_level')
    //   .subscribe((roleLevel: any) => this.allRoleLevel = roleLevel);

    this.getExperiences();

  }

  private getExperiences() {

    const token = JSON.parse(localStorage.getItem('token'));
    this.experiences$ = this.http.get('experience', { id: token.id, all: true })
      .pipe(map((result: any) => result.data));

  }

  onSelectionChange(event: any) {

    const { value, source } = event;
    source.selected.viewValue = value;

  }

  editProfessionalExperience(experience) {

    if (this.editMode && this.formVacancy.dirty && (experience.id != this.formVacancy.get('id').value)) {
      if (!confirm('O formulário ainda esta em edição, verifique se há dados alterados antes de continuar a próxima edição. Deseja continuar'))
        return;
    }

    const token = JSON.parse(localStorage.getItem('token'));

    this.editable(true);
    this.formVacancy.patchValue({
      id: experience.id,
      lead_id: token.id,
      company: experience.organization,
      vacancy: experience.professional_name,
      branch: experience.branch,
      roleLevel: experience.role_level,
      specializationName: experience.specialization_name,
      currentJob: experience.final_date === null,
      description: experience.description,
      admissionDate: moment(experience.init_date, 'YYYY-MM-DD').format('MM/YYYY'),
      departureDate: experience.final_date ? moment(experience.final_date, 'YYYY-MM-DD').format('MM/YYYY') : null,
      office: experience.office,
      salary: parseFloat(experience.salary),
      sinonimo: experience.sinonimo,
      workregime: experience.workregime,
      modalityjob: experience.modalityjob,
    })
    //this.formVacancy.markAsDirty();

  }

  editable(editable: boolean) {
    this.editMode = editable;
    const token = JSON.parse(localStorage.getItem('token'));
    this.formVacancy.reset({ lead_id: token.id, currentJob: false })
    if (editable) {
      this.formVacancy.markAsPristine();
    }

  }

  removeExperience(args, experience: any) {

    args.stopPropagation();

    if (!confirm(`Deseja realmente deletar ${experience.organization.toUpperCase()}?`))
      return;

    this.http.delete('experience', { id: experience.id })
      .subscribe(
        (result: any) => {

          if (result.type === 'OK' && result.data > 0) {
            this.snackbar.open('Experiência excluida com sucesso!', 'OK', { duration: 3000 });
            this.getExperiences();
            this.editable(false);
          } else this.snackbar.open('Não foi possivel deletar essa experiencia, tente novamente mais tarde !', 'OK', { duration: 3000 });
        },
        err => this.errorReport.showMessage(err)
      )

  }

  submitDesiredJobTitle() {

    setTimeout(() => {

      const data = this.form.getRawValue();
      data.desiredJobTitle = Array.isArray(data.desiredJobTitles) ? data.desiredJobTitles.join(', ') : data.desiredJobTitles;
      const isValid = !this.form.invalid;
      // console.log('DADOS:', data);
      if (isValid) {

        this.http.save('desired_job', data)
          .subscribe(
            (result: any) => {
              if (result.type === 'OK') {
                this.snackbar.open('As informações foram salvas com sucesso.', 'OK', { duration: 3000 });

                this.form.markAsPristine();
              }
            }
          );

      }

    }, 1000)

  }

  submitExperience() {

    const data = this.formVacancy.getRawValue();
    const isValid = !this.formVacancy.invalid;

    if (isValid) {

      data.admissionDate = moment(data.admissionDate, 'MMYYYY').format('YYYY-MM-DD');

      if (data.departureDate)
        data.departureDate = moment(data.departureDate, 'MMYYYY').format('YYYY-MM-DD');
      data['showInfo'] = true;

      const request$ = data.id
        ? this.http.save('experience:update', data)
        : this.http.save('experience', data);

      request$
        .subscribe(
          (result: any) => {

            if (result.type === 'OK') {
              this.snackbar.open('Adicionado com sucesso! ', 'OK', { duration: 3000 });
              this.getExperiences();
              this.editable(false);

              this.TokenService.atualizar();

              const params = new URLSearchParams();
              const token = JSON.parse(localStorage.getItem('token'));
              params.append('email', token.email);
              params.append('passo', '2');
      
              const hBase = this.pLocation.getBaseHrefFromDOM();
        
              this.mauticFormSrc = this.sanitazer
                .bypassSecurityTrustResourceUrl(`${hBase}mautic-form/progress?${params.toString()}`);
      

            }
          },
          err => this.errorReport.showMessage(err)
        );

    }

  }

  onBlurInput(name: string): void {

    setTimeout(() => {

      const control = this.formVacancy.get(name) || this.form.get(name);

      // console.log('Name: ',name);
      // console.log('Controle: ',control);

      if (control.value === null) return;

      let invalid = false;
      switch (name) {
        case 'vacancy': invalid = this.allVacancies.findIndex(vacancy => vacancy.professional_name.toUpperCase() === control.value.toUpperCase()) === -1; break;
        case 'specializationName': invalid = this.allSpecializationName.findIndex(specializationName => specializationName.specialization_name.toUpperCase() === control.value.toUpperCase()) === -1; break;
        case 'roleLevel': invalid = this.allRoleLevel.findIndex(roleLevel => roleLevel.role_level.toUpperCase() === control.value.toUpperCase()) === -1; break;
        case 'branch': invalid = this.allBranch.findIndex(branch => branch.branch.toUpperCase() === control.value.toUpperCase()) === -1; break;
        //case 'desiredJobTitle': invalid = this.allDesirableJobs.findIndex(_desirableJob => _desirableJob.Name === control.value) === -1; break;
        case 'sinonimo': invalid = this.allSinonimo.findIndex(_sinonimo => _sinonimo.Name === control.value) === -1; break;
      }

      if (invalid) {
        control.setValue(null);
        control.setErrors({
          invalid: true
        })
      }

    }, 500)

  }

  onBlurInput2(name: string): void {
    const control = this.form.get(name);
    if (control.value && this.filteredDesirableJobs && this.filteredDesirableJobs.findIndex(job => job.Name === control.value) === -1) {
      control.setValue(null);
      control.setErrors({ 'invalid': true });
      const campo = document.getElementById(name) as HTMLInputElement;
      if (campo) {
        campo.value = '';
      }
    }
  }

  public _filterDesirableJobs(desirableJob) {
    if (desirableJob === null) return;

    if (desirableJob.length >= 3) {
      desirableJob = accents.remove(desirableJob).toLowerCase().trim();
      return this.allDesirableJobs.filter(_desirableJobs => accents.remove(_desirableJobs.Name).toLowerCase().indexOf(desirableJob) > -1);
    } else {
      return;
    }
  }

  // private _filterVacancies(vacancy)  {
  //   if(vacancy == null) return;
  //   vacancy = accents.remove(vacancy).toLowerCase().trim();
  //   return this.allVacancies.filter(_vacancy => accents.remove(_vacancy.professional_name).toLowerCase().includes(vacancy));
  // }

  // private _filterBranch(branch)  {
  //   if(branch == null) return;
  //   branch = accents.remove(branch).toLowerCase().trim();
  //   return this.allBranch.filter(_branch => accents.remove(_branch.branch).toLowerCase().includes(branch));
  // }

  // private _filterSpecializationName(specializationName) {
  //   if(specializationName === null) return;
  //   specializationName = accents.remove(specializationName).toLowerCase().trim();
  //   return this.allSpecializationName.filter(_specialization_name => accents.remove(_specialization_name.specialization_name).toLowerCase().indexOf(specializationName) > -1);
  // }

  // private _filterRoleLevel(roleLevel) {

  //   if(roleLevel === null) return;
  //   roleLevel = accents.remove(roleLevel).toLowerCase().trim();
  //   return this.allRoleLevel.filter(_role_level => accents.remove(_role_level.role_level).toLowerCase().indexOf(roleLevel) > -1);

  // }

  public _filterSinonimo(Sinonimo) {
    if (Sinonimo === null) return;
    //Filtra apenas quando tiver mais que 3 caracteres
    if (Sinonimo.length >= 3) {
      Sinonimo = accents.remove(Sinonimo).toLowerCase().trim();
      this.filteredSinonimo = this.allSinonimo.filter(_sinonimo => accents.remove(_sinonimo.Name).toLowerCase().indexOf(Sinonimo) > -1);
    } else {
      return;
    }
  }

  onFocusInput(inputName: string) {
    const inputControl = this.formVacancy.get(inputName);
    if (inputControl) {
      const pristine = inputControl.pristine;
      if (pristine)
        inputControl.setValue(' ');
    }
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.viewValue;
    const jobs = this.form.get('desiredJobTitles').value || [];

    if (jobs.length < 3) {
      jobs.push(value);
      this.form.get('desiredJobTitles').setValue(jobs);
    }

    const campo = document.getElementById('desiredJobTitle') as HTMLInputElement;
    if (campo) {
      campo.value = '';
      this.form.get('desiredJobTitle').setValue(''); // Limpa o valor do campo no formulário
      this.desiredJobTitleInput.nativeElement.value = '';
    }
  }

  removeDesiredJob(job: string): void {
    const jobs = this.form.get('desiredJobTitles').value as string[];
    const index = jobs.indexOf(job);

    if (index >= 0) {
      jobs.splice(index, 1);
      this.form.get('desiredJobTitles').setValue(jobs);

      // Força a detecção de mudanças após a remoção do último item
      if (jobs.length === 0) {
        this.form.get('desiredJobTitle').setValue('');
        this.onFocusInput('desiredJobTitle');
        this.cdr.detectChanges();
      }
      // Habilitar o input se um cargo for removido e o limite máximo não for atingido
      if (jobs.length < 3) {
        this.form.get('desiredJobTitle').enable();
      }
    }
  }

  addDesiredJob(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.trim();

    if (!value || this.form.get('desiredJobTitles').value.length === 3) {
      // Se o valor estiver vazio ou se já houver 3 cargos selecionados, não faz nada
      return;
    }

    // Verifica se o valor está na lista de cargos desejados filtrada
    const isValidJob = this.filteredDesirableJobs.some(job => job.Name.toLowerCase() === value.toLowerCase());

    if (!isValidJob) {
      // Se o valor não estiver na lista filtrada, limpa o campo de entrada
      if (input) {
        input.value = '';
      }
      this.form.get('desiredJobTitle').setValue(''); // Limpa o valor do campo usando Angular
      return;
    }

    // Adiciona o valor à lista de cargos desejados
    const jobs = this.form.get('desiredJobTitles').value || [];
    jobs.push(value);
    this.form.get('desiredJobTitles').setValue(jobs);

    // Limpa o campo de entrada
    if (input) {
      input.value = '';
    }

  }

  close() {
    this.dialogRef.close();
  }

}